import { request } from '@/api/httpClient'

export async function organisationUpdate({ organisationId, users, defaultTicketContact, workingDays }) {
  return request({
    method: 'organisation/Update',
    payload: {
      organisationId,
      users,
      company: {
        workingDays,
        defaultTicketContact
      }
    }
  })
}

export async function organisationGet() {
  return request({
    method: 'organisation/Get'
  })
}
